module.exports = __webpack_public_path__ + "img/neu-bau-modes.49339ad8.gif";